import { render } from "./PdfsPage.vue?vue&type=template&id=05cf02cb"
import script from "./PdfsPage.vue?vue&type=script&lang=js"
export * from "./PdfsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__